import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import React, { useState } from 'react'
import * as Clipboard from 'expo-clipboard'
import { CoupanItem } from '../CoupanScreenStore';

type Props = {
    item: CoupanItem,
    onItemPress?: () => void;
}

export default function CoupanItemView(props: Props) {
    const [showCoupan, setShowCoupan] = useState(false);

    const hasCoupan = !!props.item.coupanCode;

    const handleCopy = async () => {
        if (props.item.coupanCode) {
            await Clipboard.setStringAsync(props.item.coupanCode);
            setShowCoupan(false); // ✅ go back to View button
        }
    };

    return (
        <View style={styles.item}>

            <View style={styles.leftpart}>
                <Text style={styles.title}>{props.item.title}</Text>
                <Text style={styles.description}>{props.item.description}</Text>
            </View>

            <View style={styles.rightPart}>

                {/* ✅ Only show price if no coupon */}
                {!hasCoupan && (
                    <Text style={styles.priceStyle}>
                        ₹{props.item.price}/month
                    </Text>
                )}

                {/* ✅ Show Buy if no coupon */}
                {!hasCoupan && (
                    <TouchableOpacity
                        style={styles.buyBtn}
                        onPress={props.onItemPress}
                    >
                        <Text style={styles.buyBtnText}>Buy</Text>
                    </TouchableOpacity>
                )}

                {/* ✅ If coupon exists and not opened */}
                {hasCoupan && !showCoupan && (
                    <TouchableOpacity
                        style={styles.viewBtn}
                        onPress={() => setShowCoupan(true)}
                    >
                        <Text style={styles.buyBtnText}>View Coupan</Text>
                    </TouchableOpacity>
                )}

                {/* ✅ If opened, show code + copy */}
                {hasCoupan && showCoupan && (
                    <View style={styles.coupanBox}>
                        <Text style={styles.coupanText}>
                            {props.item.coupanCode}
                        </Text>
                        <TouchableOpacity
                            style={styles.copyBtn}
                            onPress={handleCopy}
                        >
                            <Text style={styles.buyBtnText}>Copy</Text>
                        </TouchableOpacity>
                    </View>
                )}

            </View>

        </View>
    )
}

const styles = StyleSheet.create({
    item: {
        backgroundColor: '#FFFFFF',
        padding: 16,
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 10,
        borderRadius: 8
    },
    leftpart: {
        flex: 1,            // take available space
        marginRight: 10,    // spacing from right part
    },
    rightPart: {
        flexShrink: 0,      // prevent shrinking on small screens
        flexDirection: "column",
        alignItems: "flex-end",
    },
    title: {
        fontSize: 16,
        fontWeight: "500",
        marginBottom: 4
    },
    description: {
        color: "#3D3D3D",
        marginBottom: 8
    },
    priceStyle: {
        color: "#3D3D3D",
        fontSize: 22,
        fontWeight: "600",
        marginBottom: 8
    },
    buyBtn: {
        backgroundColor: "#4484FC",
        paddingVertical: 6,
        paddingHorizontal: 12,
        borderRadius: 5,
        marginTop: 5
    },
    viewBtn: {
        backgroundColor: "#22A06B",
        paddingVertical: 6,
        paddingHorizontal: 12,
        borderRadius: 5,
        marginTop: 5
    },
    copyBtn: {
        backgroundColor: "#FF7A00",
        paddingVertical: 6,
        paddingHorizontal: 12,
        borderRadius: 5,
        marginLeft: 10
    },
    coupanBox: {
        flexDirection: "row",
        alignItems: "center",
        marginTop: 5
    },
    coupanText: {
        fontWeight: "bold",
    },
    buyBtnText: {
        color: "white",
        textAlign: "center",
    }
});